/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
  // 報表類別
  {
    id: 'reports',
    title: '報表',
    type: 'group',
    icon: 'heroicons_outline:chart-bar',
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/dashboard',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'reports-watch',
        title: '收看報表',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/reports/watch',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'reports-device',
        title: '裝置收看報表',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/reports/device',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'reports-country',
        title: '分區收看報表',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/reports/country',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'reports-user',
        title: '用戶收看報表',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/reports/user',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'reports-transaction',
        title: '交易報表',
        type: 'basic',
        icon: 'heroicons_outline:credit-card',
        link: '/reports/transaction',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'reports-notification',
        title: '通知報表',
        type: 'basic',
        icon: 'heroicons_outline:bell',
        link: '/reports/notification',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'reports-daily',
        title: '日報表',
        type: 'basic',
        icon: 'heroicons_outline:calendar-days',
        link: '/reports/daily',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
    ],
  },

  // 內容管理
  {
    id: 'content',
    title: '內容',
    type: 'group',
    icon: 'heroicons_outline:film',
    children: [
      {
        id: 'series',
        title: '系列',
        type: 'basic',
        icon: 'heroicons_outline:rectangle-stack',
        link: '/content/series',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'videos',
        title: '影片',
        type: 'basic',
        icon: 'heroicons_outline:video-camera',
        link: '/content/videos',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'live-channel',
        title: 'Live Channel',
        type: 'basic',
        icon: 'heroicons_outline:rss',
        link: '/content/live-channel',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'chat-management',
        title: '聊天室管理',
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-left-right',
        link: '/content/chat-management',
        badge: {
          title: '新增',
          classes: 'px-2 bg-blue-600 text-white rounded-full',
        },
      },
      {
        id: 'sticker',
        title: '聊天室貼圖管理',
        type: 'basic',
        icon: 'heroicons_outline:face-smile',
        link: '/content/sticker',
        badge: {
          title: '新增',
          classes: 'px-2 bg-blue-600 text-white rounded-full',
        },
      },
      {
        id: 'sensitive-words',
        title: '聊天室敏感詞管理',
        type: 'basic',
        icon: 'heroicons_outline:no-symbol',
        link: '/content/sensitive-words',
        badge: {
          title: '新增',
          classes: 'px-2 bg-blue-600 text-white rounded-full',
        },
      },
      {
        id: 'video-regions',
        title: '影片地區上下架',
        type: 'basic',
        icon: 'heroicons_outline:globe-americas',
        link: '/content/video-regions',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'tag-ordering',
        title: '標籤排序',
        type: 'basic',
        icon: 'heroicons_outline:tag',
        link: '/content/tag-ordering',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'popular-keywords',
        title: '熱門關鍵字',
        type: 'basic',
        icon: 'heroicons_outline:magnifying-glass',
        link: '/content/popular-keywords',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'free-keywords',
        title: '免費首頁熱門關鍵字',
        type: 'basic',
        icon: 'heroicons_outline:star',
        link: '/content/free-keywords',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'upload',
        title: '上傳',
        type: 'basic',
        icon: 'heroicons_outline:cloud-arrow-up',
        link: '/content/upload',
        badge: {
          title: '新增',
          classes: 'px-2 bg-blue-600 text-white rounded-full',
        },
      },
      {
        id: 'transcoding',
        title: '轉檔',
        type: 'basic',
        icon: 'heroicons_outline:cog-6-tooth',
        link: '/content/transcoding',
        badge: {
          title: '新增',
          classes: 'px-2 bg-blue-600 text-white rounded-full',
        },
      },
      {
        id: 'categories-admin',
        title: '分類-後台',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/content/categories-admin',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'categories-front',
        title: '分類-前台',
        type: 'basic',
        icon: 'heroicons_outline:view-columns',
        link: '/content/categories-front',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'playlists',
        title: '播放清單',
        type: 'basic',
        icon: 'heroicons_outline:list-bullet',
        link: '/content/playlists',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'playlist-regions',
        title: '播放清單地區上下架',
        type: 'basic',
        icon: 'heroicons_outline:globe-europe-africa',
        link: '/content/playlist-regions',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'video-banners',
        title: '影片插卡廣告',
        type: 'basic',
        icon: 'heroicons_outline:photo',
        link: '/content/video-banners',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'carousel-banners',
        title: '輪播 Banners',
        type: 'basic',
        icon: 'heroicons_outline:arrow-path',
        link: '/content/carousel-banners',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'banner-regions',
        title: '輪播 Banners 地區上下架',
        type: 'basic',
        icon: 'heroicons_outline:globe-asia-australia',
        link: '/content/banner-regions',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'faqs',
        title: '常見問題',
        type: 'basic',
        icon: 'heroicons_outline:question-mark-circle',
        link: '/content/faqs',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'pages',
        title: '頁面編輯',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/content/pages',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
    ],
  },

  // 系統設定
  {
    id: 'settings',
    title: '設定',
    type: 'group',
    icon: 'heroicons_outline:cog-8-tooth',
    children: [
      {
        id: 'subscription-plans',
        title: '訂閱方案',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/settings/subscription-plans',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'redemption-code',
        title: '序號管理',
        type: 'basic',
        icon: 'heroicons_outline:ticket',
        link: '/settings/redemption-code',
      },
      {
        id: 'paypal-plans',
        title: 'PayPal 方案',
        type: 'basic',
        icon: 'heroicons_outline:credit-card',
        link: '/settings/paypal-plans',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'countries',
        title: '國家地區',
        type: 'basic',
        icon: 'heroicons_outline:globe-alt',
        link: '/settings/countries',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'waitlist-users',
        title: '候補會員',
        type: 'basic',
        icon: 'heroicons_outline:user-plus',
        link: '/settings/users/waitlist',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'users',
        title: '會員',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/settings/users',
        exactMatch: true,
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'sms-batch',
        title: '批次簡訊寄送',
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-bottom-center-text',
        link: '/settings/sms-batch',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'notifications',
        title: '通知與推播',
        type: 'basic',
        icon: 'heroicons_outline:bell-alert',
        link: '/settings/notification/tasks',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'notification-logs',
        title: '會員通知記錄',
        type: 'basic',
        icon: 'heroicons_outline:clipboard-document-list',
        link: '/settings/notification/logs',
        badge: {
          title: '新增',
          classes: 'px-2 bg-blue-600 text-white rounded-full',
        },
      },
      {
        id: 'promo-codes',
        title: '序號',
        type: 'basic',
        icon: 'heroicons_outline:ticket',
        link: '/settings/promo-codes',
        badge: {
          title: '新增',
          classes: 'px-2 bg-blue-600 text-white rounded-full',
        },
      },
      {
        id: 'languages',
        title: '語系字典',
        type: 'basic',
        icon: 'heroicons_outline:language',
        link: '/settings/languages',
      },
      {
        id: 'administrators',
        title: '管理員',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/settings/administrators',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'roles',
        title: '角色',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/settings/roles',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'advertisements',
        title: '廣告文件',
        type: 'basic',
        icon: 'heroicons_outline:megaphone',
        link: '/settings/advertisements',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
      {
        id: 'blacklist',
        title: '黑名單',
        type: 'basic',
        icon: 'heroicons_outline:check-circle',
        link: '/settings/blacklist',
        badge: {
          title: '完成',
          classes: 'px-2 bg-green-600 text-white rounded-full',
        },
      },
    ],
  },
  {
    id: 'system',
    title: '系統',
    type: 'group',
    icon: 'heroicons_outline:cog-8-tooth',
    children: [
      {
        id: 'op-menu',
        title: '選單',
        type: 'basic',
        icon: 'heroicons_outline:queue-list',
        link: '/system/menu',
      },
      {
        id: 'op-product',
        title: '產品模組',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: '/system/product',
      },
      {
        id: 'op-permission',
        title: '權限',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: '/system/permission',
      },
    ],
  },
];

export const compactNavigation: FuseNavigationItem[] = defaultNavigation;
export const futuristicNavigation: FuseNavigationItem[] = defaultNavigation;
export const horizontalNavigation: FuseNavigationItem[] = defaultNavigation;
